import axios from "axios";

const updateOptions = () => {
    if (typeof window === "undefined") return {};
};

export default async function (url: string) {
    const { data } = await axios.get(url, updateOptions());
    return data;
}